import { gql } from "@apollo/client";

const BANNER_FRAGMENT = gql`
  fragment BannerReturn on Banner {
    id
    title
    subtitle
    type
    background
    order
  }
`;

export const BANNERS = gql`
  ${BANNER_FRAGMENT}
  query BANNERS($where: BannersWhereInput) {
    banners(where: $where) {
      ...BannerReturn
    }
  }
`;

export const UPDATE_BANNER = gql`
  ${BANNER_FRAGMENT}
  mutation UPDATE_BANNER(
    $data: UpdateBannerInput!
    $where: UpdateBannerWhereInput!
  ) {
    updateBanner(data: $data, where: $where) {
      ...BannerReturn
    }
  }
`;

export const CREATE_BANNER = gql`
  ${BANNER_FRAGMENT}
  mutation CREATE_BANNER($data: CreateBannerInput!) {
    createBanner(data: $data) {
      ...BannerReturn
    }
  }
`;

export const DELETE_BANNER = gql`
  ${BANNER_FRAGMENT}
  mutation DELETE_BANNER($where: UpdateBannerWhereInput!) {
    deleteBanner(where: $where) {
      ...BannerReturn
    }
  }
`;

export const UPDATE_BANNERS_ORDER = gql`
  mutation UpdateBannersOrder($ids: [String!]!) {
    updateBannersOrder(ids: $ids)
  }
`;
